import { render, staticRenderFns } from "./PwdResetSend.vue?vue&type=template&id=42dc8843&"
import script from "./PwdResetSend.vue?vue&type=script&lang=ts&"
export * from "./PwdResetSend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports